module.exports = __webpack_public_path__ + "media/images/review/sample-photo3-12f81571e304771b04cc2f481f19da0e.png";